import {sbEditable} from '@storyblok/storyblok-editable';

import TimerContainer from './TimerContainer';

const TimerContainerStoryblok = ({blok}) => {
  const {isRounded} = blok;

  return <TimerContainer isRounded={isRounded} {...sbEditable(blok)} />;
};

export default TimerContainerStoryblok;
